import { useWindowSize } from "@hooks/useWindowSize";
import Card from "@particles/card/Card";
import { getCardVariations } from "@particles/card/templates/TemplateA/utils/helpers";
import { TemplateProps } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

/**
 * This is the template A of cards. It contains on block title and 5 story cards.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=13328-34417&t=XQDRTDj49nZblZZy-4
 */
const TemplateA = ({
  className,
  header,
  cardProps,
}: TemplateProps): React.ReactElement => {
  const { isScreenMD } = useWindowSize();

  return (
    <div
      data-testid="card-template-component"
      data-template="template-a"
      className={className}
    >
      {header}

      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-4">
        {cardProps.slice(0, 5).map((props, index) => {
          const leadArticle = index === 0;
          const cardVariations = getCardVariations(index);
          const css = cn({
            "col-span-1 row-span-2 text-center md:col-span-2 lg:text-left xl:flex-col":
              leadArticle,
            "relative xl:before:absolute xl:before:-right-4 xl:before:bottom-0 xl:before:top-0 xl:before:w-[1px] xl:before:bg-blue-100":
              leadArticle,
            "relative after:absolute after:-bottom-4 after:left-0 after:right-0 after:h-[1px] after:bg-blue-100 xl:after:hidden":
              leadArticle,
            "xl:flex-col": [1, 2].includes(index),
            "relative md:after:absolute md:after:-right-4 md:after:bottom-0 md:after:top-0 md:after:w-[1px] md:after:bg-blue-100":
              [1, 3].includes(index),
            "relative before:absolute before:-bottom-4 before:left-0 before:right-0 before:h-[1px] before:bg-blue-100":
              [1, 2, 3].includes(index),
            "md:before:-right-4 md:before:left-0 lg:before:right-0 lg:after:-bottom-4":
              index === 1,
            "md:before:-left-4 md:before:right-0 lg:before:left-0": index === 2,
            "md:before:hidden lg:after:-top-4": index === 3,
          });

          return (
            <Card
              key={props.link + props.title}
              {...props}
              displayAsTopTitle={!isScreenMD && !leadArticle}
              variations={cardVariations}
              className={css}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TemplateA;
